// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9ea72372","453":"aabb7d3f","667":"a6fd2135","977":"cea834fd"}[chunkId] + ".chunk.js";
};